import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.CheckDuplicatesPopup.PopupContent', {
    title: 'Warning',
    cancel: 'Cancel',
    description: `There is at least one other request that looks similar to the one you're currently reviewing. Please double-check it's not a duplicate:`,
    submit: 'Submit',
});
